import React from 'react';

function Trivia({ dir, root, text, number, level, isLast, onClick }) {
  let button;
  if (!isLast) {
    button = (
      <button
        onTouchStart={() => {}}
        className={'questionBtn questionNextBtn btn-' + Number(number + 1)}
        onClick={() => {
          root.dispatchEvent(
            new CustomEvent('start', {
              detail: {
                level: level + 1,
                number: number + 1,
              },
            })
          );
          onClick();
        }}
      >
        <img src={dir + 'assets/img/btn-next.png'} alt="次の謎へ" />
      </button>
    );
  } else {
    button = (
      <button onTouchStart={() => {}} className={'questionBtn questionNextBtn2 btn-' + Number(number + 1)} onClick={onClick}>
        <img src={dir + 'assets/img/btn-next2.png'} alt="次へ" />
      </button>
    );
  }
  return (
    <div className="questionContent questionUseMinDoctor questionTrivia">
      <div className="questionTxt">
        <div className="questionPageTitle">
          <img src={dir + 'assets/img/ttl-trivia.png'} alt="豆知識" />
        </div>
        <div className="questionTxtInner">
          <div className="questionTriviaImage">
            <img src={dir + 'assets/img/trivia/' + Number(level + 1) + '/trivia-' + Number(number + 1) + '.jpg'} alt="" />
          </div>
          <div className="questionTxtRight">
            <div dangerouslySetInnerHTML={{ __html: text }} />
          </div>
        </div>
        {button}
      </div>
    </div>
  );
}

export default Trivia;
